import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { SendMoneyService } from './send-money.service';

@Component({
  selector: 'app-send-money',
  templateUrl: './send-money.component.html',
  styleUrls: ['./send-money.component.scss']
})
export class SendMoneyComponent implements OnInit, OnDestroy {

  constructor(public sendMoneyService:SendMoneyService,public router:Router,private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      //console.log(params)
      let userId=params['userid']

    });
  }

  ngOnDestroy(){
    this.sendMoneyService.resetData()
  }
}
